import SEOArticlePage from "@/components/feature/SEOArticlePage";
import { articleContents } from "@/mocks/seo-article-content";

export default function SecuriteConfidentialite() {
  return <SEOArticlePage article={articleContents["securite-confidentialite"]} />;
}